import { ExecutiveBlackGold } from "@/components/templates/ExecutiveBlackGold";

// Canonical premium template. Legacy `templateId` values (beige-luxury,
// future-professional, empty/unknown) are aliased at render time to keep
// existing DB rows working without a migration. The list is intentionally
// singular; admin card badges will label everything as "Executive".
export const TEMPLATES = [
  { id: "executive-black-gold", name: "Executive" },
];

export const TemplateRenderer = ({ data }) => {
  if (!data) return null;
  return <ExecutiveBlackGold data={data} />;
};
